// Polyfill navigator.locks for iframe/preview environments and Safari Private Browsing
if (typeof navigator !== 'undefined') {
  if (!navigator.locks) {
    // Safari Private Browsing or older browsers: provide a stub
    (navigator as any).locks = {
      request: async (_name: string, ...args: any[]) => {
        const cb = args[args.length - 1];
        if (typeof cb === 'function') return cb({ name: _name, mode: 'exclusive' });
      },
    };
  } else {
    // navigator.locks exists but may time out in iframes / Safari
    const originalRequest = navigator.locks.request.bind(navigator.locks);
    (navigator.locks as any).request = async (name: string, ...args: any[]) => {
      try {
        return await Promise.race([
          originalRequest(name, ...args),
          new Promise((_, reject) =>
            setTimeout(() => reject(new Error('Lock timeout')), 3000)
          ),
        ]);
      } catch (err: any) {
        // Handle DOMException from Safari or timeout
        if (
          err?.name === 'DOMException' ||
          err?.message === 'Lock timeout' ||
          err?.message?.includes('lock')
        ) {
          const cb = args[args.length - 1];
          if (typeof cb === 'function') return cb({ name, mode: 'exclusive' });
        }
        throw err;
      }
    };
  }
}
